import { Disposable } from '@gitlab-org/disposable';
import { Transport } from '@gitlab-org/webview-transport';
import { WebviewRuntimeMessageBus } from '../../../events';
import { IsManagedEventFilter } from './event_filters';

export const setupEventSubscriptions = (
  runtimeMessageBus: WebviewRuntimeMessageBus,
  transport: Transport,
  isManaged: IsManagedEventFilter,
): Disposable[] => [
  runtimeMessageBus.subscribe(
    'plugin:notification',
    async (message) => {
      await transport.publish('webview_instance_notification', message);
    },
    isManaged,
  ),
  runtimeMessageBus.subscribe(
    'plugin:request',
    async (message) => {
      await transport.publish('webview_instance_request', message);
    },
    isManaged,
  ),
  runtimeMessageBus.subscribe(
    'plugin:response',
    async (message) => {
      await transport.publish('webview_instance_response', message);
    },
    isManaged,
  ),
];
